import QuinielaInfo from './QuinielaInfo';
export default QuinielaInfo;
